import { atom } from "jotai";

export const dashboardGradientAtom = atom<string | undefined>(undefined);
